/**
 * 市场数据服务
 */

import { apiClient } from './apiClient';

export class MarketService {
  /**
   * 获取市场数据
   */
  async getMarketData(): Promise<any> {
    const response = await apiClient.get<any>('/market/tickers', {
      params: {
        type: 'spot', // 只获取现货数据
        limit: 10, // 限制返回条数
        _t: Date.now(), // 添加时间戳破坏缓存
        _v: '4.0.0', // 添加版本号
      },
    });

    if (!response.success) {
      throw new Error(response.message || '获取市场数据失败');
    }

    return response.data;
  }


  /**
   * 获取支持的交易对
   */
  async getInstruments(instType: string = 'SPOT'): Promise<any> {
    const response = await apiClient.get<any>('/market/instruments', {
      params: {
        instType,
        _t: Date.now(), // 添加时间戳破坏缓存
        _v: '4.0.0', // 添加版本号
      },
    });

    if (!response.success) {
      throw new Error(response.message || '获取交易对信息失败');
    }

    return response.data;
  }

  /**
   * 健康检查
   */
  async healthCheck(): Promise<any> {
    const response = await apiClient.get<any>('/health', {
      params: {
        _t: Date.now(),
        _v: '4.0.0',
      },
    });

    if (!response.success) {
      throw new Error(response.message || '健康检查失败');
    }

    return response.data;
  }
}

export const marketService = new MarketService();
